const ConfirmationTypes = {
  OK_CANCEL: 'OKCANCEL',
  YES_NO: 'YESNO',
};

export default ConfirmationTypes;
